module.exports = __webpack_public_path__ + "static/media/engine.8b7616ac.svg";